import { Directive, ElementRef, HostListener } from '@angular/core';
import { AnimateArrow } from './animate-arrow';

@Directive({
  selector: '[appAnimateArrowOnHover]',
  standalone: true
})
export class AnimateArrowOnHoverDirective {
  constructor(
    private el: ElementRef,
  ) {
    this.animateArrow = new AnimateArrow();
  }

  animateArrow: AnimateArrow;

  @HostListener('mouseenter') onMouseEnter() {
    this.animateArrow.animate(this.el.nativeElement);
  }
  @HostListener('mouseleave') onMouseLeave() {
    this.animateArrow.stopAnimation(this.el.nativeElement);

    /* Just in case there is any animation left */
    this.animateArrow.stopTimeout = setTimeout(() => {
      this.animateArrow.stopAnimation(this.el.nativeElement);
    }, this.animateArrow.intervalTime + 2);
  }
}
